/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaAddressInfo = {
    ADDR: string;
    ADDRT: SomniaAddressInfo.ADDRT;
    NM: string;
    SB: string;
    BL: string;
    BLVAL: string;
    BLP: string;
    TRXCNT: string;
};

export namespace SomniaAddressInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

